export default {
  reset: () => {
    try {
      window.scrollTo(0, 0);
    } catch (e) {}
  },
  params: param => {
    try {
      window.scrollTo(param);
    } catch (e) {}
  }
};
